import React from 'react';
import { Card } from "@/components/ui/card";
import { LeadCard } from './LeadCard';
import { Lead } from './types';

interface LeadsPipelineProps {
  leads: Lead[];
  onLeadUpdated: () => void;
}

export const LeadsPipeline = ({ leads, onLeadUpdated }: LeadsPipelineProps) => {
  const stages = ['New', 'Contacted', 'Quoted', 'Sold'];
  
  const getLeadsByStage = (stage: string) => {
    return leads.filter(lead => lead.pipeline_stage === stage);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stages.map((stage) => (
        <Card key={stage} className="p-4">
          <h3 className="text-xl font-semibold mb-4">
            {stage} ({getLeadsByStage(stage).length})
          </h3>
          <div className="space-y-4 min-h-[200px]">
            {getLeadsByStage(stage).map((lead) => (
              <LeadCard 
                key={lead.id} 
                lead={lead} 
                onLeadUpdated={onLeadUpdated}
              />
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
};